<template>
    <div>

        <h2 class="t-c" v-if="!entity.proposal_addendums_attributes || entity.proposal_addendums_attributes.length === 0">Não há adendos para essa proposta</h2>

        <div class="container" v-for="(ad, idx) in entity.proposal_addendums_attributes" :key="ad.id">
            <label class="dt f-w-b">{{ad.created_at | formatDate('DD/MM/YYYY H:mm')}}</label>
            <div class="notes" v-if="!ad.edit_mode">{{ad.notes}}</div>
            <div v-else>
                <textarea v-model="ad.notes"
                          maxlength="4000"
                          required
                          class="form-control form-control-sm"></textarea>
            </div>

            <div class="act">
                <button type="button"
                        class="btn btn-sm"
                        :title="ad.edit_mode ? 'Fechar edição' : 'Modificar'"
                        :class="{'btn-warning': !$appUtils.isMobile(), 'btn-dark': ad.edit_mode}"
                        @click="toggleEditMode(idx, !ad.edit_mode)">
                    <svg-icon :icon="!ad.edit_mode ? 'pencil-alt' : 'times'"/>
                </button>
                <button type="button"
                        v-if="!ad.edit_mode"
                        title="Remover"
                        class="btn btn-sm"
                        :class="{'btn-danger': !$appUtils.isMobile()}"
                        @click="destroy(ad.id)"
                ><svg-icon icon="trash-alt"/></button>
                <button type="button"
                        v-if="!ad.edit_mode"
                        title="Download"
                        class="btn btn-sm"
                        :class="{'btn-dark': !$appUtils.isMobile()}"
                        @click="downloadPdf(ad)"
                ><svg-icon :class="{'refresh rotate-1-seg': ad.runningDownload}" :icon="ad.runningDownload ? 'sync' : 'cloud-download-alt'"/></button>
                <button type="button"
                        v-if="!ad.edit_mode"
                        title="Visualizar"
                        class="btn btn-sm"
                        :class="{'btn-info': !$appUtils.isMobile()}"
                        @click="viewPdf(ad.id)"
                ><svg-icon icon="search"/></button>
                <button type="button"
                        v-if="!ad.edit_mode"
                        title="Enviar por e-mail"
                        @click="$emit('onSendByEmail', {id: ad.id, type: 'addendum'})"
                        class="btn btn-sm"
                        :class="{'btn-secondary': !$appUtils.isMobile()}"><svg-icon icon="envelope"/></button>
            </div>
        </div>
        <br/>
        <br/>
        <div class="t-r" v-if="entity.id > 0 && !entity.canceled">
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="addAddendum">
                <svg-icon icon="plus"/> Adicionar Adendo
            </button>
        </div>
    </div>
</template>

<script>
    import {mapMutations, createNamespacedHelpers} from 'vuex'
    const {mapActions} = createNamespacedHelpers('proposals');

    export default {
        name: "AddendumArea",
        props: {
            entity: {
                type: Object,
                required: true,
                default: {}
            }
        },
        methods: {
            ...mapMutations(['addModal', 'destroyModal']),
            ...mapActions(['destroyAddendum']),
            toggleEditMode(idx, is) {
                const addendums = this.entity.proposal_addendums_attributes;

                if (!is && !addendums[idx].id) {
                    this.$delete(this.entity.proposal_addendums_attributes, idx);
                } else {
                    this.$set(addendums, idx, {...addendums[idx], edit_mode: is})
                }
            },
            viewPdf(id) {
                const params = new URLSearchParams({url: `/v1/proposals/view/pdf_addendum?id=${id}&d=attachment`, name: `Adendo Confirmação de negócio - ${this.entity.number}.pdf`});
                this.$router.push({path: `/pdf-viewer?${params.toString()}`})
            },
            downloadPdf(ad) {
                this.$set(ad, 'runningDownload', true);
                this.$appUtils.downloadPdf(`/v1/proposals/view/pdf_addendum?id=${ad.id}&d=attachment`, `Adendo Confirmação de negócio - ${this.entity.number}.pdf`)
                    .catch(err => {
                        this.$snotify.error(this.$t('common.downloadPdfError'), this.$appStorage.getUser().name);
                        console.error(err);
                    })
                    .finally(() => setTimeout(() => this.$set(ad, 'runningDownload', false), 1000));
            },
            addAddendum() {

                if (!this.$appUtils.isArray(this.entity.proposal_addendums_attributes))
                    this.$set(this.entity, 'proposal_addendums_attributes', []);

                this.entity.proposal_addendums_attributes.push({
                    edit_mode: true,
                    notes: '',
                    proposal_id: this.entity.id,
                    created_at: new Date()
                })
            },
            destroy(addendum_id) {
                this.addModal({
                    title: 'Adendo', size: 'small', body: 'Deseja remover esse adendo?', buttons: [
                        {
                            type: 'ok', class: 'btn btn-theme-1 btn-sm', method: id => {
                                this.destroyAddendum(addendum_id)
                                    .then(() => {
                                        this.$delete(this.entity.proposal_addendums_attributes, this.entity.proposal_addendums_attributes.indexById({id: addendum_id}));
                                        this.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);

                                        this.$emit('onUpdateTabs', {});
                                    });
                                this.destroyModal(id);
                            }
                        },
                        {type: 'close', label: 'Não', method: this.destroyModal}
                    ]
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .container {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-areas: 'dt' 'notes' 'act';
        grid-template-rows: auto;
        grid-gap: 5px;
        padding: 5px;

        .dt {
            grid-area: dt;
            text-align: right;
        }

        .notes {
            grid-area: notes;
        }

        .act {
            grid-area: act;
            text-align: right;

            .btn {
                color: #fff;

                &:not(:last-child) {
                    margin-right: 5px;
                }
            }

        }
    }

    .btn-enter-active, .btn-leave-active {
        transition: opacity .1s ease-in-out;
    }
    .btn-enter, .btn-leave-to {
        opacity: 0;
    }

    @media (max-width: 576px) {
        .container .act {
            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }
        }
    }
</style>
